import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarm,
  CPSConfigAlarmElement,
  CPSConfigCard,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P00037Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('elSAlarme') === 1 || true) {
    if (getValue('elSProtectionHivernage') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.protectionHivernage',
      });
    }

    if (getValue('elSCaracteristiqueCelluleUtilise') === 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.caraccelluleutilise',
      });
    }

    if (getValue('elSDefautCourant') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.defautCourant',
      });
    }

    if (getValue('elSMesureDebit') === 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.detectionDebit',
      });
    }

    if (getValue('elSSecuriteDesinfection') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.secuDesinfection',
      });
    }

    if (getValue('elSNiveauSelBas') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.tauxselbassin',
        ctaTitle: 'P00037.status.tauxselbassin.value',
        ctaFn: (editValue: any) => {
          editValue(P00039DataRxTxIndex.SALT_Controle, 'elCResetNiveauSel', 1);
        },
      });
    }

    if (getValue('elSProtectionPresenceGaz') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.protectionpresenceGaz',
        ctaTitle: 'P00037.status.protectionpresenceGaz.value',
        ctaFn: (editValue: any) => {
          editValue(
            P00039DataRxTxIndex.SALT_Controle,
            'elCResetProtectionPresenceGaz',
            1,
          );
        },
      });
    }

    if (getValue('elSProtectionThermique') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.protectionthermique',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        functionalityTitle: 'P00037.dashboard.electrolyseur',
        title: 'P00037.status.connexionCoffret',
      });
    }
  }

  return res;
}
